(() => {
  const openClass = 'promo-modal-open';

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function openModal(modal) {
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(openClass);
    document.body.classList.add(openClass);

    // Focus first input if possible
    const first = qs('input, textarea, button', modal);
    if (first) first.focus();
  }

  function closeModal(modal) {
    if (!modal) return;

    // IMPORTANT: move focus OUT of the modal before hiding it (prevents aria-hidden warning)
    const active = document.activeElement;
    if (active && modal.contains(active)) {
      // Focus the opener button if we can find it, else just blur
      active.blur();
    }

    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(openClass);
    document.body.classList.remove(openClass);
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = isLoading;
    btn.classList.toggle('is-loading', isLoading);
  }

  function setStatus(form, type, msg) {
    const status = qs('[data-promo-status]', form);
    if (!status) return;
    status.classList.remove('is-success', 'is-error');
    status.textContent = msg || '';
    if (type === 'success') status.classList.add('is-success');
    if (type === 'error') status.classList.add('is-error');
  }

  function getAutoCloseAndMsg(form) {
    const wrapper = qs('.promo-modal__grid', form);
    return {
      autoClose: (wrapper?.getAttribute('data-auto-close') || 'false') === 'true',
      successMsg: wrapper?.getAttribute('data-success-message') || 'Thanks — we’ve got it. We’ll be in touch shortly.'
    };
  }

  function formToUrlEncoded(form) {
    const fd = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of fd.entries()) params.append(k, typeof v === 'string' ? v : '');
    return params;
  }

  function ensureHiddenInput(form, name, value) {
    let input = qs(`input[name="${CSS.escape(name)}"]`, form);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  // ---------- Modal open/close events ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-promo-modal-open]');
    if (!btn) return;

    const targetId = btn.getAttribute('data-promo-modal-open');
    const modal = targetId ? document.getElementById(targetId) : null;
    if (!modal) return;

    e.preventDefault();
    openModal(modal);
  });

  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-promo-modal-close]');
    if (closeBtn) {
      closeModal(e.target.closest('.promo-modal'));
      return;
    }
    if (e.target.closest('.promo-modal__backdrop')) {
      closeModal(e.target.closest('.promo-modal'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openEl = qs('.promo-modal[aria-hidden="false"]');
    if (openEl) closeModal(openEl);
  });

  // ---------- Submission ----------
  async function handleSubmit(form) {
    const submitBtn = qs('button[type="submit"]', form);
    setStatus(form, null, '');
    setLoading(submitBtn, true);

    try {
      // Shopify required fields (usually already present, but safe)
      ensureHiddenInput(form, 'form_type', 'contact');
      ensureHiddenInput(form, 'utf8', '✓');

      // If you have Shopify captcha enabled, AJAX may still fail.
      // We try AJAX first. If it errors, we fall back to normal submit.
      const body = formToUrlEncoded(form);
      const action = form.getAttribute('action') || '/contact';

      const res = await fetch(action, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body
      });

      // If Shopify blocks (400), throw so we fall back
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const ok = html.includes('contact_posted=true');

      if (!ok) throw new Error('No contact_posted flag');

      const { autoClose, successMsg } = getAutoCloseAndMsg(form);
      setStatus(form, 'success', successMsg);
      form.reset();

      if (autoClose) {
        const modal = form.closest('.promo-modal');
        setTimeout(() => closeModal(modal), 1400);
      }
    } catch (err) {
      // Fallback to normal submit so Shopify captcha can do its thing (this will refresh)
      console.warn('[Promo modal contact] AJAX failed, falling back to normal submit:', err);
      setLoading(submitBtn, false);
      form.submit();
      return;
    } finally {
      // If AJAX succeeded, this runs; if we fell back, we already returned
      setLoading(submitBtn, false);
    }
  }

  // Capture-phase intercept
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('promo-contact-form')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    handleSubmit(form);
  }, true);

  // ---------- Show success after refresh ----------
  function showSuccessAfterRefreshIfNeeded() {
    const url = new URL(window.location.href);
    const posted = url.searchParams.get('contact_posted') === 'true';
    if (!posted) return;

    // If hash points to a specific promo form, use it
    const hash = window.location.hash || '';
    const targetFormId = hash.startsWith('#') ? hash.slice(1) : '';
    let form = targetFormId ? document.getElementById(targetFormId) : null;

    // If not found, fallback to first promo contact form
    if (!form || !(form instanceof HTMLFormElement)) {
      form = qs('form.promo-contact-form');
    }
    if (!form) return;

    const modal = form.closest('.promo-modal');
    if (!modal) return;

    openModal(modal);

    const { autoClose, successMsg } = getAutoCloseAndMsg(form);
    setStatus(form, 'success', successMsg);

    // Clean the URL so refresh/back button doesn't keep reopening it
    url.searchParams.delete('contact_posted');
    history.replaceState({}, '', url.pathname + url.search + url.hash);

    if (autoClose) {
      setTimeout(() => closeModal(modal), 2200);
    }
  }

  document.addEventListener('DOMContentLoaded', showSuccessAfterRefreshIfNeeded);
})();
